export const retailerContentClasses =
  "mx-auto w-full max-w-[1536px] px-4 lg:px-12";
